var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.isUserEmployee ? _c('v-layout', {
    staticStyle: {
      "gap": "10px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_vm.value.isSuccess === null ? [_vm.isUserEmployer ? [_c('reply-dialog', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "outlined": "",
            "width": "73",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('span', [_vm._v("채용")])])];
      }
    }], null, false, 748681713)
  }, 'reply-dialog', {
    value: _vm.value,
    program: _vm.program,
    isSuccess: true,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer
  }, false), {
    input: _vm.input
  })), _c('reply-dialog', _vm._g(_vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var attrs = _ref2.attrs,
          on = _ref2.on;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "outlined": "",
            "width": "73",
            "color": "grey-d"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "grey--text"
        }, [_vm._v("미채용")])])];
      }
    }], null, false, 1742478455)
  }, 'reply-dialog', {
    value: _vm.value,
    program: _vm.program,
    isSuccess: false,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer
  }, false), {
    input: _vm.input
  }))] : [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "73",
      "color": "primary lighten-5"
    }
  }, [_c('span', {
    staticClass: "primary--text"
  }, [_vm._v("면접예정")])])]] : _vm._e(), _vm.value.isSuccess === true ? [_c('reply-employ', _vm._b({
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var attrs = _ref3.attrs,
          on = _ref3.on;
        return [_vm.isUserEmployer ? [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "width": "73",
            "color": "primary lighten-5"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "primary--text"
        }, [_vm._v("채용")])])] : [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "small": "",
            "width": "73",
            "color": "secondary lighten-5"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "secondary--text"
        }, [_vm._v("채용완료")])])]];
      }
    }], null, false, 2245129057)
  }, 'reply-employ', {
    value: _vm.value
  }, false))] : _vm._e(), _vm.value.isSuccess === false ? [_c('v-btn', {
    attrs: {
      "small": "",
      "width": "73",
      "color": "grey lighten-5"
    }
  }, [_c('span', {
    staticClass: "grey--text"
  }, [_vm._v("미채용")])])] : _vm._e()], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }